import React, {ReactElement, ReactNode} from 'react';

interface Props {
  errorMessage?: ReactNode;
  warningMessage?: ReactNode;
}

const ErrorMessage = ({errorMessage = '', warningMessage = ''}: Props): ReactElement | null =>
  errorMessage || warningMessage ? (
    <div
      className={`field__assistiveText ${warningMessage ? 'field__assistiveText--warning' : ''} ${
        errorMessage ? 'field__assistiveText--error' : ''
      }`}
    >
      {errorMessage || warningMessage}
    </div>
  ) : null;

export default ErrorMessage;
